import { useEntityPageContext } from './EntityContext';

/** The top hashtags or keywords section, for whichever source's section `as` is. */
const EntityTopTerms = ({
    as: Section,
    exportType = 'hashtag',
    exportEntity,
    highlighted = false,
    paginateBy,
    dated = true,
    ...rest
}) => {
    const {
        entityId,
        entityType,
        countryIds,
        country,
        week,
        year,
        name,
        exportName,
    } = useEntityPageContext();
    const ids =
        entityType === 'brands'
            ? { brands: [entityId], countries: countryIds }
            : { categories: [entityId], countries: countryIds };

    return (
        <Section
            enabled={
                dated
                    ? !!(week && year && entityId && country)
                    : !!(entityId && country)
            }
            data={{ ...ids, ...(dated && { week, year }) }}
            {...(paginateBy && { paginateBy })}
            name={name || null}
            {...(highlighted && { highlight: name || null })}
            filename={exportName(
                exportType,
                exportEntity === undefined ? {} : { entity: exportEntity },
            )}
            {...rest}
        />
    );
};

export default EntityTopTerms;
